export const NEGATIVE_ACCRUAL_TYPE = "NEGATIVE";
export const POSITIVE_ACCRUAL_TYPE = "POSITIVE";
